var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"poppins-thin",staticStyle:{"font-size":"10px"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.toUpperCase == true ? _vm.subtitle.toUpperCase() : _vm.subtitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }